export type LottoOutcome = 'won' | 'lost-remaining' | 'lost-exhausted';

interface ResolveLottoOutcomeParams {
  /** 추첨 당첨 여부 */
  isWin: boolean;
  /** 응모 후 남은 응모권 수 */
  remainingTicketCount: number;
  /** 1회 응모에 필요한 응모권 수 */
  requiredTicketCount: number;
}

/**
 * 로또 응모 결과 모달 variant를 파생한다(flow-map L).
 * - 당첨: won
 * - 낙첨 & 남은 응모권으로 재응모 가능: lost-remaining
 * - 낙첨 & 응모권 소진(재응모 불가): lost-exhausted
 */
export const resolveLottoOutcome = ({
  isWin,
  remainingTicketCount,
  requiredTicketCount,
}: ResolveLottoOutcomeParams): LottoOutcome => {
  if (isWin) {
    return 'won';
  }

  return remainingTicketCount >= requiredTicketCount
    ? 'lost-remaining'
    : 'lost-exhausted';
};
